// src/main.jsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './App.css';
import './i18n'; // initialize i18next before any component renders
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { Analytics } from '@vercel/analytics/react';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
      <Analytics />
    </ErrorBoundary>
  </React.StrictMode>
);
